import React from 'react';
import { Collapse, Typography } from 'antd';

const { Panel } = Collapse;
const { Title, Paragraph } = Typography;

const FAQ = () => {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto' }}>
      <Title level={2} style={{ textAlign: 'center', marginBottom: '24px' }}>
        SellBoost AI – Frequently Asked Questions
      </Title>
      
      <Collapse accordion>
        {/* Question 1 */}
        <Panel header="What is SellBoost AI?" key="1">
          <Paragraph>
            SellBoost AI is a Shopify app that helps you generate high-converting, SEO-optimized product descriptions using artificial intelligence. 
            It saves time and boosts sales by delivering compelling content tailored to your audience and brand tone.
          </Paragraph>
        </Panel>

        {/* Question 2 */}
        <Panel header="How does SellBoost AI generate product descriptions?" key="2">
          <Paragraph>
            We offer two powerful modes:
          </Paragraph>
          <ul>
            <li>
              <strong>Smart Configuration:</strong> You provide key details like tone, keywords, product type, and CTA style. 
              The AI builds a conversion-optimized description for you.
            </li>
            <li>
              <strong>Custom Prompt:</strong> Write your own prompt or use example prompts to get fully customized results. 
              Great for experienced marketers who want fine-tuned control.
            </li>
          </ul>
        </Panel>

        {/* Question 3 */}
        <Panel header="Can I edit or enhance the AI-generated description?" key="3">
          <Paragraph>
            Yes! After generation, you can freely edit or enhance the output directly in the app before publishing it to your Shopify store.
          </Paragraph>
        </Panel>

        {/* Question 4 */}
        <Panel header="What are example prompts in the Custom Prompt section?" key="4">
          <Paragraph>
            Example prompts are pre-written instructions that you can use as templates to inspire or customize your own prompts. 
            They help you guide the AI to generate descriptions in a specific style or with specific objectives.
          </Paragraph>
        </Panel>

        {/* Question 5 */}
        <Panel header="Can I use both configuration and custom prompt at the same time?" key="5">
          <Paragraph>
            You can choose either the configuration-based setup or the custom prompt mode. This ensures clarity for the AI and avoids conflicting instructions. 
            Each mode is optimized for different levels of user control.
          </Paragraph>
        </Panel>

        {/* Question 6 */}
        <Panel header="How does the credit system work?" key="6">
          <Paragraph>
            You receive a fixed number of AI credits based on your plan. Each product description generation consumes a small amount of credit. 
            If you run out of credits, you can purchase more anytime.
          </Paragraph>
        </Panel>

        {/* Question 7 */}
        <Panel header="What kind of tone and styles can the AI write in?" key="7">
          <Paragraph>
            SellBoost AI supports a variety of tones like:
          </Paragraph>
          <ul>
            <li>Professional</li>
            <li>Casual</li>
            <li>Luxury</li>
            <li>Minimal</li>
            <li>Fun</li>
          </ul>
          <Paragraph>
            You can choose a tone during setup, or express it in your custom prompt.
          </Paragraph>
        </Panel>

        {/* Question 8 */}
        <Panel header="Can I use SellBoost AI for any type of product?" key="8">
          <Paragraph>
            Yes, SellBoost AI works with any product category—from fashion and electronics to beauty, fitness, and home goods. 
            Just select or describe the product type, and the AI adapts accordingly.
          </Paragraph>
        </Panel>

        {/* Question 9 */}
        <Panel header="Will this affect my Shopify SEO?" key="9">
          <Paragraph>
            Absolutely—in a good way! The AI naturally integrates your target keywords and follows SEO best practices to improve visibility and search performance.
          </Paragraph>
        </Panel>

        {/* Question 10 */}
        <Panel header="Is image analysis supported?" key="10">
          <Paragraph>
            Not yet—but it's coming soon. We're working on a feature that allows SellBoost AI to understand your product image and enhance descriptions based on visual elements.
          </Paragraph>
        </Panel>

        {/* Question 11 */}
        <Panel header="How can I get support?" key="11">
          <Paragraph>
            You can contact us directly through the app's support tab or email us at <a href='mailto:contactsellBoostai@gmail.com'>contactsellBoostai@gmail.com</a>. We're here to help with anything you need.
          </Paragraph>
        </Panel>
      </Collapse>
    </div>
  );
};

export default FAQ;